import React from 'react'
import { Container, Panel } from 'rsuite'
import { useTranslation } from "react-i18next"
import { Capabilities, hasPermission } from '@/shared'
import LanguageSwitcher from '@client/components/LanguageSwitcher'
import TenantSettings from './TenantSettings'
import MappingHints from './MappingHints'


export default function Settings() {
  const { t } = useTranslation();

  return (
    <Container>
      <Panel bordered header={t('Settings')}>
        <LanguageSwitcher />
      </Panel>

      <TenantSettings />

      {/* Hidden rather than read-only for somebody who cannot see a converter:
          the list is field names and nothing else, and without the mapping in
          front of them it would mean nothing. */}
      {hasPermission(Capabilities.convert_read) && <MappingHints />}
    </Container>
  )
}
